import { AppUser } from "../app-user";
import { AdministrativeUnit } from "../organizations/administrative-unit";
import { EmailAddress } from "./email-address";

export class EmailMessage {
  id: string;
  toAddresses: EmailAddress[];
  blindCCs: EmailAddress[];
  cCs: EmailAddress[];
  subject: string;
  body: string;
  sentOn: string;
  responseCode: string;
  responseMessage: string;
  expanded: boolean;
  emailStatus: string;

  createdOn: Date;
  createdBy: AppUser;
  administrativeUnit: AdministrativeUnit;
  tagIds: string[];

  public constructor(init?: Partial<EmailMessage>) {
    Object.assign(this, init);
  }
}
